export const genderValues = {
  label: "Gender",
  options: [
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
  ],
};

export const seatPreferenceValues = {
  label: "Seat Preferences",
  options: [
    {
      label: "1",
      value: "1",
    },
    {
      label: "2",
      value: "2",
    },
    {
      label: "3",
      value: "3",
    },
    {
      label: "4",
      value: "4",
    },
  ],
};

export const mealPreferenceValues = {
  label: "Meal Preference",
  options: [
    {
      label: "Vegan",
      value: "vegan",
    },
    {
      label: "Meat",
      value: "meat",
    },
    {
      label: "Mixed",
      value: "mixed",
    },
  ],
};

export const specialAsistanceValues = {
  label: "Special Asistance",
  options: [
    {
      label: "Yes",
      value: "true",
    },
    {
      label: "No",
      value: "false",
    },
  ],
};

export const billingAddress = {
  label: "Billing Address",
  options: [
    {
      label: "Use the same billing address",
      value: "default",
    },
    {
      label: "Use another billing address",
      value: "other",
    },
  ],
};
